import React from 'react'
import PropTypes from 'prop-types'
import "./RadioButton.scss"
import classnames from 'classnames'
import HrbTranslate from '../../language/HrbTranslate';

const RadioButton = props => {
    const { params, elementId } = props;

    const handleChecked = () => {
        if (!props.disabled && props.onChecked) {
            props.onChecked(elementId);
        }
    }

    return (
        <div className='spark-rb' onClick={handleChecked}>
            <div className='hrb-radio-wrapper'>
                <div id={elementId} className={classnames('hrb-radio-button', { 'checked': props.checked, 'disabled': props.disabled })} />
            </div>
            {props.textKey &&
                <label htmlFor={elementId} className='rb-label p1'>
                    <HrbTranslate text={props.textKey} params={params} />
                </label>
            }
        </div>
    )
}

RadioButton.propTypes = {
    textKey: PropTypes.string,
    params: PropTypes.object,
    checked: PropTypes.bool,
    onChecked: PropTypes.func,
    elementId: PropTypes.string.isRequired,
    disabled: PropTypes.bool
}

export default RadioButton